<template>
  <div
    id="kt_header"
    class="header header-fixed page-header tw:z-98 tw:transition-[right] tw:duration-200"
    :class="{ 'tw:right-(--sidebar-width)!': open && isDashboardOrSettingsPage }"
  >
    <slot />
  </div>
</template>

<script setup>
import { useRoutePage } from '@/hooks/use-route-page.js'
import { useSidebar } from '@/shadcn/components/ui/sidebar'

const { open } = useSidebar()
const { isDashboardOrSettingsPage } = useRoutePage()
</script>
